import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import useAuth0ClientConfig from '../../lib/auth0/use-auth0-client-config'
import SignUpForm, {
  OnSuccess,
  OnFailure,
  RenderLoginLink,
} from '../../components/forms/sign-up'
import useLogger from '../../lib/logger/use-logger'
import useNotifications from '../../lib/notifications/use-notifications'
import {
  makeAppleLogin,
  makeGoogleLogin,
  makeValidateSignUpEmail,
} from '../../lib/apiService'
import OnboardingPage from '../onboarding-page'
import { LOGIN, VERIFY_CODE } from '../paths'
import useAnalytics from '../../lib/analytics/use-analytics'
import { signUpSteps, trackGoToLoginLink } from '../../lib/analytics/events'
import { UserFlow } from '../../lib/apiService/realApi'
interface Props {
  setEmail(email: string): void
  draftEmail: string
  setDraftEmail(email: string): void
  setActionName(actionName: string): void
}

const SignUpPage: React.FC<Props> = (props) => {
  const history = useHistory()
  const logger = useLogger()
  const { setNotification, clearNotifications } = useNotifications()
  const { dataLayer } = useAnalytics()
  const { cookieDomain } = useAuth0ClientConfig()

  const onChangeEmail = (email: string) => {
    props.setDraftEmail(email)
  }

  const onSuccess: OnSuccess = (data) => {
    props.setEmail(data.email)
    props.setActionName('sign-up')
    dataLayer(signUpSteps(1))
    history.push(VERIFY_CODE)
  }

  const onFailure: OnFailure = () => {
    setNotification({
      id: 'sign-up-page/on-failure',
      type: 'failure',
      message:
        'There was a problem loading this information. Please try again.',
    })
  }

  const renderLoginLink: RenderLoginLink = (className) => (
    <Link
      to={LOGIN}
      onClick={() => dataLayer(trackGoToLoginLink())}
      className={className}
    >
      Login
    </Link>
  )

  const validateSignUpEmail = makeValidateSignUpEmail({ logger })
  const googleLogin = makeGoogleLogin({
    logger,
    dataLayer,
    userFlow: UserFlow.SIGN_UP_GOOGLE,
    cookieDomain,
  })

  const appleLogin = makeAppleLogin({
    logger,
    dataLayer,
    userFlow: UserFlow.SIGN_UP_APPLE,
    cookieDomain,
  })

  return (
    <OnboardingPage>
      <SignUpForm
        draftEmail={props.draftEmail}
        onChangeEmail={onChangeEmail}
        onSuccess={onSuccess}
        onFailure={onFailure}
        validateSignUpEmail={(...args) => {
          clearNotifications()
          return validateSignUpEmail(...args)
        }}
        renderLoginLink={renderLoginLink}
        googleLogin={googleLogin}
        appleLogin={appleLogin}
      />
    </OnboardingPage>
  )
}

export default SignUpPage
